import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import useRegions from '../../utils/useRegions.js';
import * as S from './style.js';
import { PATHS } from '../../config.js';

const CountryItem = (code, name) => {
  return (
    <p key={code}>
      <Link to={`${code}/${PATHS.FORM}`} reloadDocument={true}>
        {name}
      </Link>
    </p>
  );
};

const CountryModal = () => {
  const { getCountryCodesAndNames } = useRegions();
  const [showModal, setShowModal] = useState(false);
  const { pathname } = useLocation();
  const lang = pathname.split('/')[1];
  useEffect(() => {
    setShowModal(lang.length !== 2);
  }, [lang]);
  return showModal ? (
    <S.CountryModal>
      <div className="modal-content">
        <h3>Please choose your country</h3>
        <hr />
        {getCountryCodesAndNames().map(([code, name]) => CountryItem(code, name))}
      </div>
    </S.CountryModal>
  ) : null;
};

export default CountryModal;
